import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import TitleBar from '../../Layout/TitleBar';
import Layout from '../../Layout/Layout';

const ShoppingListPlaceholder = () => {
  const { t } = useTranslator();

  return (
    <Layout>
      <TitleBar showBackBtn={false}>{t('shoppingList.navbarTitle')}</TitleBar>
      <section className="placeholder-glow page-template-shopping-list">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="shopping-list-search">
                  <h3 className="title-medium semi-bold text-center pt-m">
                    {t('shoppingList.dateRange.title')}
                  </h3>
                  <div className="d-flex">
                    <FormGroup className="w-50 me-1">
                      <div className="placeholder form-control">&nbsp;</div>
                    </FormGroup>
                    <FormGroup className="w-50 ms-1">
                      <div className="placeholder form-control">&nbsp;</div>
                    </FormGroup>
                  </div>

                  <Button color="primary" disabled className="placeholder w-100 mb-xl">
                    {t('shoppingList.dateRange.button')}
                  </Button>

                  <hr className="m-0" />
                </div>

                <div className="shopping-list-container">
                  <div className="text-center mb-xl">
                    <p className="placeholder title-small mb-0">Your shopping list</p>
                    <br />
                    <p className="placeholder title-small mt-xxs mb-0">
                      from 9/23/2024 to 9/30/2024
                    </p>
                  </div>

                  <div class="ingredient-info-notification d-flex align-items-center">
                    <p className="placeholder"></p>
                  </div>

                  <h3 className="title-large semi-bold d-none d-md-block placeholder w-100">
                    &nbsp;
                  </h3>
                  <h3 className="title-medium semi-bold d-md-none placeholder w-100">&nbsp;</h3>
                  <ul className="ingredients">
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                    <li className="placeholder w-100">&nbsp;</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};

export default ShoppingListPlaceholder;
